// /* @flow */
export const SELECT_TIME_SLOT = 'SELECT_TIME_SLOT'
export const LOAD_UPSELLS_MODULE = 'upsells/LOAD_UPSELLS_MODULE'
export const CLICK_INVENTORY = 'upsells/CLICK_INVENTORY'
export const CHANGE_INVENTORY_QUANTITY = 'upsells/CHANGE_INVENTORY_QUANTITY'
export const CLICK_INVENTORY_DESCRIPTION = 'upsells/CLICK_INVENTORY_DESCRIPTION'
export const INITIALIZE_UPGRADES_STATE = 'INITIALIZE_UPGRADES_STATE'
export const SAVE_SELECTED_ACTUAL_UPGRADES_TO_STATE = 'SAVE_SELECTED_ACTUAL_UPGRADES_TO_STATE'
export const RE_INITIALIZE_UPGRADES = 'RE_INITIALIZE_UPGRADES'
